module.exports = __webpack_public_path__ + "static/media/piaic-logo-new.1624cca8.svg";